/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type NotificationType = 'INFO' | 'CONTRACT' | 'CONTRACT_PAYMENT' | 'PERSONAL_DATA' | 'ESIGN';

export const NotificationType = {
    INFO: 'INFO' as NotificationType,
    CONTRACT: 'CONTRACT' as NotificationType,
    CONTRACT_PAYMENT: 'CONTRACT_PAYMENT' as NotificationType,
    PERSONAL_DATA: 'PERSONAL_DATA' as NotificationType,
    ESIGN: 'ESIGN' as NotificationType
};

